import {Routes} from "@angular/router";
import {loggedGuard} from "./guards/logged.guard";
import {onboardingGuard} from "./modules/onboarding/guards/onboarding.guard";
import {authenticationRoutes} from "./modules/auth/auth-routing.module";

export const appRoutes: Routes = [
  {
    path: "work/:type/:workId/:slug",
    loadComponent: () =>
      import("./modules/works/pages/public-work/public-work.component").then(
        (m) => m.PublicWorkComponent
      ),
  },
  {
    path: "work/:type/:workId",
    loadComponent: () =>
      import("./modules/works/pages/public-work/public-work.component").then(
        (m) => m.PublicWorkComponent
      ),
  },
  ...authenticationRoutes,
  {
    path: "",
    canActivateChild: [loggedGuard, onboardingGuard],
    loadChildren: () =>
      import("./modules/lists/lists-routing.module")
        .then((m) => m.listsRoutes)
        .catch((err: Error) => {
          console.error("Chunk load error:", err);
          // Force reload to get the new version of the app and prevent chunk load error
          globalThis.location.reload();
          throw err;
        }),
  },
  {
    path: "account",
    canActivate: [loggedGuard, onboardingGuard],
    loadChildren: () =>
      import("./modules/account/account-routing.module")
        .then((m) => m.AccountRoutingModule)
        .catch((err: Error) => {
          console.error("Chunk load error:", err);
          // Force reload to get the new version of the app and prevent chunk load error
          globalThis.location.reload();
          throw err;
        }),
  },
  {
    path: "friends",
    canActivate: [loggedGuard, onboardingGuard],
    loadChildren: () =>
      import("./modules/friends/friends-routing.module")
        .then((m) => m.friendsRoutes)
        .catch((err: Error) => {
          console.error("Chunk load error:", err);
          // Force reload to get the new version of the app and prevent chunk load error
          globalThis.location.reload();
          throw err;
        }),
  },
  {
    path: "compass",
    canActivate: [loggedGuard, onboardingGuard],
    loadChildren: () =>
      import("./modules/compass/compass-routing.module")
        .then((m) => m.compassRoutes)
        .catch((err: Error) => {
          console.error("Chunk load error:", err);
          // Force reload to get the new version of the app and prevent chunk load error
          globalThis.location.reload();
          throw err;
        }),
  },
  {
    path: "onboarding",
    canActivate: [loggedGuard],
    loadChildren: () =>
      import("./modules/onboarding/onboarding-routing.module")
        .then((m) => m.onboardingRoutes)
        .catch((err: Error) => {
          console.error("Chunk load error:", err);
          globalThis.location.reload();
          throw err;
        }),
  },
  {
    path: "subscription",
    canActivate: [loggedGuard, onboardingGuard],
    loadChildren: () =>
      import("./modules/subscription/subscription-routing.module")
        .then((m) => m.subscriptionRoutes)
        .catch((err: Error) => {
          console.error("Chunk load error:", err);
          globalThis.location.reload();
          throw err;
        }),
  },
  {
    path: "stats",
    canActivate: [loggedGuard, onboardingGuard],
    loadComponent: () =>
      import("./modules/stats/pages/dashboard/dashboard.component")
        .then((m) => m.DashboardComponent)
        .catch((err: Error) => {
          console.error("Chunk load error:", err);
          // Force reload to get the new version of the app and prevent chunk load error
          globalThis.location.reload();
          throw err;
        }),
  },
  {
    path: "users",
    canActivate: [loggedGuard, onboardingGuard],
    loadChildren: () =>
      import("./modules/users/users-routing.module")
        .then((m) => m.usersRoutes)
        .catch((err: Error) => {
          console.error("Chunk load error:", err);
          // Force reload to get the new version of the app and prevent chunk load error
          globalThis.location.reload();
          throw err;
        }),
  },
  {
    path: "admin",
    loadChildren: () =>
      import("./modules/admin/admin-routing.module")
        .then((m) => m.adminRoutes)
        .catch((err: Error) => {
          console.error("Chunk load error:", err);
          globalThis.location.reload();
          throw err;
        }),
  },
  {
    path: "about",
    canActivate: [loggedGuard, onboardingGuard],
    loadComponent: () =>
      import("./pages/about/about.component")
        .then((m) => m.AboutComponent)
        .catch((err: Error) => {
          console.error("Chunk load error:", err);
          // Force reload to get the new version of the app and prevent chunk load error
          globalThis.location.reload();
          throw err;
        }),
  },
];
